// Lightweight postal-code patterns by country.
// Sources: ISO 3166-1 + national postal services.
// Patterns are *advisory* , we only flag clearly wrong inputs, never block.
const PATTERNS = {
  US: /^\d{5}(-\d{4})?$/,                                  // 12345 or 12345-6789
  CA: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,            // K1A 0B1
  GB: /^[A-Z]{1,2}\d[A-Z\d]?[ ]?\d[A-Z]{2}$/i,            // SW1A 1AA
  IM: /^IM\d[A-Z\d]?[ ]?\d[A-Z]{2}$/i,
  JE: /^JE\d[A-Z\d]?[ ]?\d[A-Z]{2}$/i,
  GG: /^GY\d[A-Z\d]?[ ]?\d[A-Z]{2}$/i,
  IE: /^[A-Z]\d{2}[ ]?[A-Z\d]{4}$/i,                       // D02 X285
  AU: /^\d{4}$/,
  NZ: /^\d{4}$/,
  DE: /^\d{5}$/,
  FR: /^\d{5}$/,
  ES: /^\d{5}$/,
  IT: /^\d{5}$/,
  PT: /^\d{4}-?\d{3}$/,
  NL: /^\d{4}[ ]?[A-Z]{2}$/i,
  BE: /^\d{4}$/,
  CH: /^\d{4}$/,
  AT: /^\d{4}$/,
  SE: /^\d{3}[ ]?\d{2}$/,
  NO: /^\d{4}$/,
  DK: /^\d{4}$/,
  FI: /^\d{5}$/,
  PL: /^\d{2}-\d{3}$/,
  IN: /^\d{6}$/,
  JP: /^\d{3}-?\d{4}$/,
  CN: /^\d{6}$/,
  BR: /^\d{5}-?\d{3}$/,
  MX: /^\d{5}$/,
  ZA: /^\d{4}$/,
  SG: /^\d{6}$/,
  HK: /^$/,                                                // Hong Kong has no postal codes
  AE: /^$/,
};

const COUNTRY_NAME_TO_CODE = {
  "United States": "US",
  "United Kingdom": "GB",
  "Northern Ireland": "GB",
  "Isle of Man": "IM",
  "Jersey": "JE",
  "Guernsey": "GG",
  "Ireland": "IE",
  "Canada": "CA",
  "Australia": "AU",
  "New Zealand": "NZ",
  "Germany": "DE",
  "France": "FR",
  "Spain": "ES",
  "Italy": "IT",
  "Portugal": "PT",
  "Netherlands": "NL",
  "Belgium": "BE",
  "Switzerland": "CH",
  "Austria": "AT",
  "Sweden": "SE",
  "Norway": "NO",
  "Denmark": "DK",
  "Finland": "FI",
  "Poland": "PL",
  "India": "IN",
  "Japan": "JP",
  "China": "CN",
  "Brazil": "BR",
  "Mexico": "MX",
  "South Africa": "ZA",
  "Singapore": "SG",
  "Hong Kong": "HK",
  "United Arab Emirates": "AE",
};

export function validatePostalCode(countryName, postal) {
  if (!postal) return { valid: true, hint: null };
  const code = COUNTRY_NAME_TO_CODE[countryName];
  if (!code) return { valid: true, hint: null };
  const pattern = PATTERNS[code];
  if (!pattern) return { valid: true, hint: null };
  const ok = pattern.test(postal.trim());
  if (ok) return { valid: true, hint: null };

  // Soft hint, not a blocker , keep human-friendly examples
  const hints = {
    US: "Use 12345 or 12345-6789",
    CA: "Use format like K1A 0B1",
    GB: "Use format like SW1A 1AA",
    IE: "Use format like D02 X285",
    AU: "4 digits, e.g. 2000",
    NZ: "4 digits, e.g. 6011",
    DE: "5 digits, e.g. 10115",
    FR: "5 digits, e.g. 75001",
    ES: "5 digits, e.g. 28001",
    IT: "5 digits, e.g. 00100",
    PT: "Format 1234-567",
    NL: "Format 1234 AB",
    BR: "Format 12345-678",
    JP: "Format 100-0001",
  };
  return { valid: false, hint: hints[code] || "Doesn't match this country's format" };
}
